import {
  Component, EventEmitter, Input, Output,
} from '@angular/core';
import { IconComponentStyles } from '../icon/icon.component';
import { IconOptions } from '@angular/material/icon';

@Component({
  selector: 'app-search-filter',
  templateUrl: './search-filter.component.html',
  styleUrls: [ './search-filter.component.scss' ],
})
export class SearchFilterComponent {
  @Input() value = ''
  @Input() icon = 'search';
  @Input() iconStyle: IconComponentStyles = 'outlined';
  @Input() placeholder = 'Search';
  @Input() customHeight = '24px';
  @Input() customFontSize = '16px';
  @Input() delayMs: number;
  @Output() valueChange = new EventEmitter<string>();
  @Input() searchStyle: 'default' | 'gray' = 'default';


  pendingValue = '';

  delay() {
    const delayVal = this.delayMs !== undefined ? this.delayMs : 500;

    return new Promise( resolve => setTimeout(resolve, delayVal) );
  }

  async handleValueChange(event: any) {
    const value = event?.target?.value;
    this.pendingValue = value;
    await this.delay();

    if (this.pendingValue !== value) {
      return;
    }
    this.valueChange.emit(value);
  }
}
